import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DownloadIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Download",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M25.63 16.69c.37-.48.59-1.08.59-1.74v-.03c0-1.68-1.37-3.05-3.05-3.05h-.18c-.68.03-1.29.29-1.77.7a6.747 6.747 0 0 0-13.43.95v.13c0 .42.05.83.13 1.23v-.04h-.77c-.42 0-.83.06-1.23.16h.03c-2.29.56-3.97 2.6-3.97 5.03s1.67 4.47 3.93 5.03h.04c.36.1.77.16 1.19.16h18.72c2.29-.07 4.12-1.95 4.12-4.25s-1.91-4.26-4.26-4.26h-.14l.03-.02Zm-5.57.9-3.92 3.92c-.16.16-.38.26-.62.26s-.46-.1-.62-.26l-3.92-3.92a.87.87 0 0 1 .57-1.53h2.67v-3.92h2.62v3.92h2.67a.87.87 0 0 1 .57 1.53Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M16 29.01c-.55 0-1-.45-1-1v-7c0-.55.45-1 1-1s1 .45 1 1v7c0 .55-.45 1-1 1"
      }), /*#__PURE__*/_jsx("path", {
        d: "M16 29.01c-.26 0-.51-.1-.71-.29l-4-4a.996.996 0 1 1 1.41-1.41l3.3 3.3 3.3-3.3a.996.996 0 1 1 1.41 1.41l-4 4c-.2.2-.45.29-.71.29M22 18H9.99c-.55 0-1-.45-1-1s.45-1 1-1H22c.55 0 1 .45 1 1s-.45 1-1 1"
      }), /*#__PURE__*/_jsx("path", {
        d: "M10 18c-2.76 0-5-2.24-5-5s2.24-5 5-5c.55 0 1 .45 1 1s-.45 1-1 1c-1.66 0-3 1.35-3 3s1.35 3 3 3c.55 0 1 .45 1 1s-.45 1-1 1"
      }), /*#__PURE__*/_jsx("path", {
        d: "M5.99 14c-.55 0-1-.45-1-1 0-2.76 2.24-5 5-5 1.78 0 3.44.96 4.33 2.5.28.48.11 1.09-.36 1.37-.48.28-1.09.11-1.37-.36a3.002 3.002 0 0 0-5.6 1.5c0 .55-.45 1-1 1ZM22 18c-.55 0-1-.45-1-1s.45-1 1-1c1.66 0 3-1.35 3-3s-1.35-3-3-3c-.55 0-1-.45-1-1s.45-1 1-1c2.76 0 5 2.24 5 5s-2.24 5-5 5"
      }), /*#__PURE__*/_jsx("path", {
        d: "M22 10c-.55 0-1-.45-1-1 0-2.21-1.8-4-4-4-1.27 0-2.44.58-3.2 1.6-.33.44-.96.53-1.4.2s-.53-.96-.2-1.4C13.35 3.87 15.1 3 17 3c3.31 0 6 2.69 6 6 0 .55-.45 1-1 1"
      })]
    })
  }));
};